import React from "react"
import ArrowIcon from "../assets/images/ArrowIconWhite.svg"
import CountDownTimer from "./CountDownTimer"
import ReadMore from "./ReadMore"
import { useDispatch, useSelector } from "react-redux"
import { redirectToOmnicuris } from "../utilities"
import { useHistory } from "react-router-dom"
import { isAuthenticated } from "../utilities"
import { INITIATE_AUTH_DRAWER } from "../actions/types"

function Webinars(props) {
  const { children, classes, webinarLabel, webinarTitle, launchTimeStr, launchTime, showRegisterButton, description, courseId, courseSlug, upComingWebinar, isSeries, isWebinarCompleted, platformType } = props
  const { domainDetails } = useSelector((state) => state.listings)

  const history = useHistory()
  const dispatch = useDispatch()

  const redirectTo = (ev) => {
    ev.stopPropagation()
    if (!isAuthenticated() && window.self === window.top) {
      dispatch({
        type: INITIATE_AUTH_DRAWER,
      })
    } else {
      // if (domainDetails && domainDetails.orgType === 'certifier') {
      //   if (upComingWebinar.completed) {
      //     if (platformType === 'CME') {
      //       redirectToOmnicuris(`/academics/${courseSlug}/${upComingWebinar.seriesId}/${upComingWebinar.id}`,window.self != window.top);
      //     } else {
      //       redirectToOmnicuris(`/oc-originals/${courseSlug}/${upComingWebinar.seriesId}/${upComingWebinar.id}`,window.self != window.top);
      //     }
      //   } else {
      //     redirectToOmnicuris(`/oc-live/${upComingWebinar.id}`,window.self != window.top);
      //   }
      // } else {
      if (upComingWebinar.completed) {
        history.push(`/academics/${courseSlug}/${upComingWebinar.id}`)
      } else {
        history.push(`/live/${upComingWebinar.id}`)
      }
      // }
    }
  }

  return (
    <section data-aos={domainDetails.orgType === "certifier" ? "fade-up" : ""} className="webinarsSection">
      <div className={`webinars ${classes && classes}`}>
        <div className="webinarMask" />
        <article>
          <div className="webinarTopSection">
            <section>
              <h3 className="webinarHeading">{webinarLabel}</h3>
              <h1>{webinarTitle}</h1>
            </section>
            {description && <ReadMore className={"webinarsDescription"} content={description} showAsHTML={false} />}
            <section className="launchInfo">
              <h3>{launchTimeStr}</h3>
              {isWebinarCompleted ? null : <CountDownTimer launchTime={launchTime} />}
            </section>
          </div>

          {showRegisterButton && (
            <button className="registerButton" onClick={redirectTo}>
              {isWebinarCompleted ? "Watch Now" : "Register Now"} <img src={ArrowIcon} alt="" />
            </button>
          )}
          <div className="webinarMiddleSection slickArrows">{children}</div>
        </article>
      </div>
    </section>
  )
}

export default Webinars
